// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tooltip_wrapper__11vfv","tooltip":"Tooltip_tooltip__1K7qB","text":"Tooltip_text__3g1wQ"};